import { AdornedInput, Input, Adornment } from '@zillow/constellation';
import PropTypes from 'prop-types';
import withLabel from './withLabel';

const InputField = ({ disabled, error, leftAdornment, rightAdornment, name, register, registerProps, ...props }) => (
    <AdornedInput
        inputId={props.id || name}
        disabled={disabled}
        error={!!error}
        leftAdornment={leftAdornment && <Adornment>{leftAdornment}</Adornment>}
        rightAdornment={rightAdornment && <Adornment>{rightAdornment}</Adornment>}
        input={<Input {...props} {...register(name, registerProps)} />}
    />
);

InputField.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    leftAdornment: PropTypes.node,
    rightAdornment: PropTypes.node,
    error: PropTypes.object,
    register: PropTypes.func,
    registerProps: PropTypes.object,
};

InputField.defaultProps = {
    registerProps: {},
    register: () => {},
};

const LabeledInputField = withLabel(InputField);

export default LabeledInputField;
